import React, { useState } from 'react';
import TodoForm from './TodoForm';
import { GiDeathSkull } from 'react-icons/gi';
import { BsVectorPen } from 'react-icons/bs';

const Todo = ({ todos, completeTodo, editTodo, removeTodo }) => {
  const [edit, setEdit] = useState({
    id: null,
    value: ''
  });

  const submitUpdate = value => {
    editTodo(edit.id, value);
    setEdit({
        id: null,
        value: ''
    });
  };

  if (edit.id) {
    return <TodoForm edit={edit} onSubmit={submitUpdate} />;
  }

  return todos.map((todo, index) => (
    <div
    className={todo.isComplete ? 'todo-row complete' : 'todo-row'} 
    key={index}
    >
        <div key={todo.id} onClick={() => completeTodo(todo.id)}>
            {todo.text}
        </div>

        <div className="icons">
          <GiDeathSkull 
          onClick={() => removeTodo(todo.id)}
          className='delete-icon'
          />
          <BsVectorPen 
          onClick={() => setEdit({ id: todo.id, value: todo.text })}
          className='edit-icon'
          />
          </div>
        </div>
  ));
};

export default Todo;